// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xUQCil {
  padding: var(--spacing-3);
  font-family: var(--font-family-base, 'Source Sans 3');
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 100%;
}

.Iz0ugU {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 0; /* center vertically within li */
}

.SB0n7z {
  height: var(--spacing-2);
  width: var(--spacing-2);
}

.Cda5m8 {
  margin: var(--spacing-3) 0 var(--spacing-1) 0;
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-lg);
}

.U1up4e {
  margin: 0;
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md);
}

.iSwKaP {
  margin-top: auto; /* push button to bottom */
}

.llx4IT {
  width: 100%;
}

.csA9R5 {
  margin-top: var(--spacing-4);
}

.vv7r2p {
  height: var(--spacing-9);
  width: var(--spacing-9);
  border-radius: var(--spacing-9);
  background: var(--surface-primary-subtle);
  display: flex;
  align-items: center;
  justify-content: center;
}

.CABIh_ {
  background: var(--info-blue-light, #e5f4ff);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/DrawerOperator/components/EmptyOperatorsList/EmptyOperatorsList.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":[".emptyState {\n  padding: var(--spacing-3);\n  font-family: var(--font-family-base, 'Source Sans 3');\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: auto 0; /* center vertically within li */\n}\n\n.icon {\n  height: var(--spacing-2);\n  width: var(--spacing-2);\n}\n\n.title {\n  margin: var(--spacing-3) 0 var(--spacing-1) 0;\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-lg);\n}\n\n.description {\n  margin: 0;\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md);\n}\n\n.button {\n  margin-top: auto; /* push button to bottom */\n}\n\n.fullWidthButton {\n  width: 100%;\n}\n\n.smallWidthButton {\n  margin-top: var(--spacing-4);\n}\n\n.iconWrapper {\n  height: var(--spacing-9);\n  width: var(--spacing-9);\n  border-radius: var(--spacing-9);\n  background: var(--surface-primary-subtle);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.iconWrapperEmptyState {\n  background: var(--info-blue-light, #e5f4ff);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `xUQCil`,
	"content": `Iz0ugU`,
	"icon": `SB0n7z`,
	"title": `Cda5m8`,
	"description": `U1up4e`,
	"button": `iSwKaP`,
	"fullWidthButton": `llx4IT`,
	"smallWidthButton": `csA9R5`,
	"iconWrapper": `vv7r2p`,
	"iconWrapperEmptyState": `CABIh_`
};
module.exports = ___CSS_LOADER_EXPORT___;
